// src/utils/authUtils.js
import { auth } from '../config/firebase';
import app from '../config/firebase';
import { getAuth } from 'firebase/auth';
import { getCurrentUserSession } from '../context/UserSessionContext';

/**
 * Get the current authenticated user ID
 * @returns {string} Current user ID
 * @throws {Error} If no user is authenticated
 */
export function getCurrentUserId() {
  const currentUser = auth.currentUser;
  
  if (!currentUser) {
    throw new Error('No authenticated user found. Please log in.');
  }
  
  return currentUser.uid;
}

export async function createAuthHeaders() {
  const idToken = await getAuth(app).currentUser.getIdToken(true);

  const headers = {
    'Authorization': `Bearer ${idToken}`,
    'Content-Type': 'application/json'
  };

  // Automatically check if impersonation is active
  try {
    const userSession = getCurrentUserSession();
    if (userSession && userSession.isImpersonating && userSession.effectiveUserId) {
      headers['X-Impersonate-User'] = userSession.effectiveUserId;
      console.log('Auth: Adding impersonation header for user:', 
        userSession.effectiveUserId.substring(0, 8) + '...');
    }
  } catch (error) {
    // If we can't get user session (e.g., outside React component tree), 
    // just continue without impersonation - this is non-critical
    console.warn('Auth: Could not check impersonation status:', error.message);
  }

  return headers;
}

/**
 * Validate that user is authenticated
 * @returns {string} User ID if authenticated
 * @throws {Error} If no user is authenticated
 */
export function validateUserAuth() {
  const userId = getCurrentUserId();
  
  console.log('User authenticated:', { userId: userId.substring(0, 8) + '...' });
  
  return userId;
}

/**
 * Check if user is currently authenticated
 * @returns {boolean} True if user is authenticated
 */
export function isUserAuthenticated() {
  return auth.currentUser !== null;
}